import { User } from './user';
import { Box } from "./box";
import { Contract } from "./contract";

export class Researcher extends User {

  address?: string | undefined;
  macAddress?: string | undefined;
  organizationName?: string | undefined;

  boxes?: Box[];
  contracts?: Contract[];

}
